import { Component, OnInit } from '@angular/core';
import { fadeInOut } from '../../shared/helpers/animations';
import { IPermission } from '../../shared/models/index';
import { StorageManagerService } from '../../shared/services';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Component({
    selector: 'app-accessdenied',
    templateUrl: './accessdenied.component.html',
    styleUrls: ['./accessdenied.component.scss'],
    animations: [fadeInOut],
    standalone: false
})

export class AccessdeniedComponent implements OnInit {
    hasApplicationPermission: boolean;
    message: string;

    // Constructor
    constructor(private storageManagerService: StorageManagerService, private authenticationService: AuthenticationService) {
    }

    ngOnInit(): void {
        this.message = 'This account is not associated with any company that has an active subscription'
            + ' to a health authority. Please contact your Reed Tech Sales Representative and inquire'
            + ' about activating a subscription. You are being logged out.';

        setTimeout(this.logout, 5000, this);
    }

  logout(thisComponent: AccessdeniedComponent) {

    let accessPermissions: IPermission[];

    accessPermissions = this.storageManagerService.read('accessPermissions');

     const email = thisComponent.storageManagerService.read('accessDeniedEmail');

        if (accessPermissions && email) {
            this.authenticationService.captureLogoutEvent(email)
                .subscribe(res => {
                    thisComponent.authenticationService.logout();
                    thisComponent.storageManagerService.clearAll();
                },
                    error => console.error(error));
        } else {
            thisComponent.authenticationService.logout();
            thisComponent.storageManagerService.clearAll();
        }
    }
}
